/* global cast */
var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Chromecast = youbora.Adapter.extend({

  /** Override to be able to get HTML video element and Cast player */
  constructor: function (player, castPlayer) {
    this.castPlayer = castPlayer
    youbora.adapters.Chromecast.__super__.constructor.call(this, player)
  },

  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.player.getEstimatedTime || this.player.currentTime
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.player.duration
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    if (this.castPlayer && this.castPlayer.getStreamingProtocol) {
      var protocol = this.castPlayer.getStreamingProtocol()
      if (protocol.getStreamCount && protocol.getStreamCount() > 0) {
        for (var c = 0; c < protocol.getStreamCount(); c++) {
          var streamInfo = protocol.getStreamInfo(c)
          if (streamInfo.mimeType.indexOf('video/') === 0) {
            var videoLevel = protocol.getQualityLevel(c)
            if (streamInfo.bitrates && streamInfo.bitrates[videoLevel]) {
              return streamInfo.bitrates[videoLevel]
            }
          }
        }
      }
    }
    return null
  },

  /** Override to return rendition */
  getRendition: function () {
    var ret = null
    if (this.player && this.player.videoHeight && this.player.videoWidth) {
      var bitrate = this.plugin.getBitrate()
      if (bitrate <= 0) {
        bitrate = this.plugin.requestBuilder.lastSent['bitrate'] || -1
      }
      ret = youbora.Util.buildRenditionString(this.player.videoWidth, this.player.videoHeight, bitrate)
    }
    return ret
  },

  /** Override to return resource URL. */
  getResource: function () {
    var ret = null
    if (!this.player.currentSrc.startsWith('blob:')) {
      ret = this.player.currentSrc
    } else if (this.castPlayer) {
      ret = this.castPlayer.getHost().url
    }
    return ret
  },

  /** Override to return current playrate */
  getPlayrate: function () {
    return this.player.playbackRate
  },

  /** Override to return dropped frames since start */
  getDroppedFrames: function () {
    return this.player.webkitDroppedFrameCount
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    var ret = null
    if (typeof cast !== 'undefined' && cast.player && cast.player.api) {
      ret = cast.player.api.VERSION
    }
    return ret
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'Chromecast'
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Console all events if logLevel=DEBUG
    youbora.Util.logAllEvents(this.player)

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, false, 1200)

    // Register listeners
    this.references = {
      loadstart: this.playListener.bind(this),
      pause: this.pauseListener.bind(this),
      playing: this.playingListener.bind(this),
      error: this.errorListener.bind(this),
      seeking: this.seekingListener.bind(this),
      abort: this.endedListener.bind(this),
      ended: this.endedListener.bind(this),
      buffering: this.bufferingListener.bind(this)
    }
    this.hostReferences = {
      onAutoPause: this.autoPauseListener.bind(this)
    }

    for (var key in this.references) {
      this.player.addEventListener(key, this.references[key])
    }

    if (this.castPlayer && this.castPlayer.getHost && this.castPlayer.getHost()) {
      var host = this.castPlayer.getHost()
      for (var key2 in this.hostReferences) {
        host[key2] = this.hostReferences[key2]
      }
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    if (this.monitor) this.monitor.stop()

    // unregister listeners
    if (this.player && this.references) {
      if (typeof this.player.removeEventListener === 'function') {
        for (var key in this.references) {
          this.player.removeEventListener(key, this.references[key])
        }
      }
      delete this.references
    }
    if (this.castPlayer && this.castPlayer.getHost && this.castPlayer.getHost()) {
      var host = this.castPlayer.getHost()
      for (var key2 in this.hostReferences) {
        host[key2] = null
      }
      delete this.hostReferences
    }
  },

  /** Listener for 'play' event. */
  playListener: function (e) {
    this.fireStart()
  },

  /** Listener for 'pause' event. */
  pauseListener: function (e) {
    if (!this.flags.isBuffering) {
      this.firePause()
    }
  },

  /** Listener for 'playing' event. */
  playingListener: function (e) {
    this.fireResume()
    this.fireSeekEnd()
    this.fireBufferEnd()
    this.fireJoin()
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    // // Extract only serializable error information to avoid circular references
    var errorInfo = {
      type: e.type || 'error',
      message: e.message || 'Unknown error',
      code: e.code || null,
      timestamp: Date.now()
    }

    // Add player-specific error details if available
    if (this.player && this.player.error) {
      errorInfo.playerErrorCode = this.player.error.code
      errorInfo.playerErrorMessage = this.player.error.message
    }
    this.fireError(e)
  },

  /** Listener for 'ended' event. */
  endedListener: function (e) {
    this.fireStop()
  },

  /** Listener for 'seeking' event. */
  seekingListener: function (e) {
    this.fireSeekBegin()
  },

  /** Listener for 'buffering' event. */
  bufferingListener: function (e) {
    if (this.flags.isPaused) {
      this.fireResume()
    }
    this.fireBufferBegin()
  },

  autoPauseListener: function (e) {
    if (e) {
      this.fireResume()
      this.fireBufferBegin()
    } else {
      this.fireBufferEnd()
    }
  }
})

module.exports = youbora.adapters.Chromecast
